import { session } from 'wix-storage';
export const MAX_STORAGE_ITEM_LEN = 45000;

export function saveToStorage(key, data) {
	session.setItem(key, data)
}

export function readFromStorage(key) {
	let value = session.getItem(key);
	if (value)
		return (JSON.parse(value));
	return null;
}

export function removeFromStorage(key) {
	return session.removeItem(key)
}

export function getFromIndexDB(key) {
	const storeName = 'tempdata';
	const dbName = 'tempDB';
	return new Promise((resolve, reject) => {
		if (indexedDB) {

			let open = indexedDB.open(dbName); // Open (or create) the database
			// Create the schema
			
			open.onupgradeneeded = function (e) {
				
				e.target.transaction.abort();
				return resolve(undefined)
			}
			open.onerror = function (event) {
				return resolve(undefined)
			};
			open.onsuccess = function () {
				
				// Start a new transaction
				let db = open.result;
				db.onerror = function (event) {
					reject(undefined);
				};
				if (!db.objectStoreNames.contains(storeName)) {
					return resolve(undefined);
				}
				let tx = db.transaction(storeName, 'readonly');
				let store = tx.objectStore(storeName);

				// Query the data
				let getItem = store.get(key);
				return getItem.onsuccess = async function () {
					try {
						let storedItem = await getItem.result;
						if (storedItem){
							
							db.close();
							return resolve(storedItem.item);
						}
						return resolve(storedItem);
					} catch (e) {
						return reject('stored item error');
					}
				};

			}
			
		} else {
			
			reject('No index-db');
		}
		
	})
}

export function setToIndexDB(key, item) {
	const storeName = 'tempdata';
	const dbName = 'tempDB';
	return new Promise((resolve, reject) => {
		if (indexedDB) {
			let open = indexedDB.open(dbName); // Open (or create) the database
			
			open.onupgradeneeded = function (e) {
				
				let db = open.result;
				let tempStore = db.createObjectStore(storeName, { keyPath: 'id' });
				tempStore.onsuccess = function () {
					
					// let tx = db.transaction(storeName, 'readwrite');
					// let store = tx.objectStore(storeName);
					tempStore.put({ id: key, item });
					// tx.oncomplete = function () {
					// 	db.close();
					// }
					db.close();
					resolve(true);

				}

			}
			open.onsuccess = function (e) {
			
			let db = open.result;
			if (!db.objectStoreNames.contains(storeName)) {
				let tempStore = db.createObjectStore(storeName, { keyPath: 'id' });
				tempStore.onsuccess = function (ev) {
					
					// let tx = db.transaction(storeName, 'readwrite');
					// let store = tx.objectStore(storeName);
					tempStore.put({ id: key, item });
					// tx.oncomplete = function () {
					// 	db.close();
					// }
					ev.target.close();
					db.close();
					resolve(true);

				}
			} else {
				let tx = db.transaction(storeName, 'readwrite');
				let store = tx.objectStore(storeName);
				store.put({ id: key, item });
				tx.oncomplete = function () {
					db.close();
					resolve(true);
				}
			}

			}
			open.onerror = function (event) {
				reject('open index-db error');
			}
		} else {
			reject('No index-db');
		}
	})
}

export function deleteIndexDB() {
	const storeName = 'tempdata';
	const dbName = 'tempDB';
	return new Promise((resolve, reject) => {
		if (indexedDB) {
			
			let DBDeleteRequest = indexedDB.deleteDatabase(dbName,1);
			
			DBDeleteRequest.onerror = function (event) {
				
				//console.log("Error deleting database.");
			};

			DBDeleteRequest.onsuccess = function (event) {
				
				// console.log("Database deleted successfully");
			};
			DBDeleteRequest.onblocked = function (event) {
				
				//console.log("Database blocked successfully");
			};
		}
	})
}